import { render } from "./EventTypeTable.vue?vue&type=template&id=469e6aae"
import script from "./EventTypeTable.vue?vue&type=script&lang=js"
export * from "./EventTypeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__